<script>
	import thumb_7rmhgQzc47Q from '$lib/Components/Youtube/images/7rmhgQzc47Q.jpg?w=610';

	import Button from '$lib/Components/Layout/Button/Button.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import Youtube from '$lib/Components/Youtube/Youtube.svelte';
</script>

<Section backgroundColor="grey-medium">
	<h2
		class="
    max-w-150 text-left text-indow-white
    md:text-center
  "
	>
		Why IndowONE Inserts Work
	</h2>
	<p class="max-w-150 text-left text-indow-white">
		Our Snug Fit compression tubing and <a href="/how-to/insulate-your-home"
			>premium insulating acrylic</a
		> creates a near airtight seal in your existing window frames to reduce noise
		and temperature transfer - without requiring modifications to your existing window
		frames.
	</p>

	<Youtube
		posterImageSrc={thumb_7rmhgQzc47Q}
		videoId="7rmhgQzc47Q"
		title="Introducing A Revolutionary Window Insert | Indow®"
	/>

	<p class="max-w-150 text-left text-indow-white">
		We use laser measurements and our proprietary software to custom make your
		inserts to the exact dimensions of your windows. Simply press them into
		place and watch them blend in - you'll notice the difference right away!
	</p>

	<div class="mx-auto w-full max-w-150 text-center">
		<h3
			class="
     mb-0 rounded-t-xl bg-indow-white px-6 pt-2 pb-1 text-lg font-bold
     text-indow-grey-dark
     sm:text-xl
   "
		>
			INDOW INSERT PERFORMANCE
		</h3>
		<div
			class="
     rounded-b-xl border-3 border-indow-white bg-indow-grey-medium p-3
     sm:p-6
   "
		>
			<ul
				class="
      mb-8 flex w-full list-none flex-wrap justify-evenly gap-3 gap-y-6
      sm:gap-6
    "
			>
				<li class="flex flex-col-reverse gap-3">
					<h4 class="mb-0 font-medium text-indow-white">
						ENERGY<br />SAVINGS
					</h4>
					<p
						class="
        rounded-xl bg-indow-white p-3 text-center
        sm:p-5
      "
					>
						<span class="text-sm font-medium">AVERAGE</span><br />
						<span
							class="
         text-3xl font-bold
         sm:text-4xl
       ">20%</span
						>
					</p>
				</li>
				<li class="flex flex-col-reverse gap-3">
					<h4 class="mb-0 font-medium text-indow-white">
						NOISE<br />REDUCTION
					</h4>
					<p
						class="
        rounded-xl bg-indow-white p-3 text-center
        sm:p-5
      "
					>
						<span class="text-sm font-medium">UP TO</span><br />
						<span
							class="
         text-3xl font-bold
         sm:text-4xl
       ">70%</span
						>
					</p>
				</li>
				<li class="flex flex-col-reverse gap-3">
					<h4 class="mb-0 font-medium text-indow-white">
						PERFECT<br />FIT RATE
					</h4>
					<p
						class="
        rounded-xl bg-indow-white p-3 text-center
        sm:p-5
      "
					>
						<span class="text-sm font-medium">OVER</span><br />
						<span
							class="
         text-3xl font-bold
         sm:text-4xl
       ">99%</span
						>
					</p>
				</li>
			</ul>
			<Button href="/performance">Learn More</Button>
		</div>
	</div>
</Section>
